<!--Navigation Bar-->
<app-navbar>
  <h2>{{'AGRI_PERSONALITY.TITLE' | translate}}</h2>
</app-navbar>

<div class="privacy-layout pt-100 pb-100">
  <div class="container">
    <div class="row">
      <div class="col-8 mb-5">
        <div class="col-12 bg-white pb-10">
          <div class="job-details-item px-5 pt-5">
            <!-- <div class="col-12 p-0">
                            <h4 class="custom-section-title">1. Aspecte generale</h4>
                        </div> -->
            <div class="content">
              <div [innerHTML]="'AGRI_PERSONALITY.TEXT_HTML1' | translate"></div>
              <ol [innerHTML]="'AGRI_PERSONALITY.TEXT_HTML2' | translate">
              </ol>
              <div class="row">
                <div class="col-6" [innerHTML]="'AGRI_PERSONALITY.TEXT_HTML3' | translate">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <img src="../../../assets/img/diploma.jpg">
    </div>
    </div>
  </div>
</div>

<!--Footer-->
<app-footer></app-footer>
